export default "__VITE_ASSET__D4r6Usw6__"